module.exports = __webpack_public_path__ + "img/audit_de.73a33f35.png";